import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Logo } from "../components/Logo";
import { toast } from "sonner";

export default function Login() {
    const { login, t, apiErr } = useApp();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setErr(""); setLoading(true);
        try {
            const u = await login(email, password);
            toast.success("Welcome back.");
            nav(u.role === "admin" ? "/admin" : "/assessment");
        } catch (e) {
            setErr(apiErr(e.response?.data?.detail) || e.message);
        }
        setLoading(false);
    };

    return (
        <div className="max-w-md mx-auto px-4 sm:px-8 py-16 lg:py-24">
            <div className="text-center mb-8">
                <Link to="/" className="text-2xl inline-block"><Logo /></Link>
                <h1 className="mt-5 text-3xl text-charcoal">Welcome back</h1>
                <p className="mt-2 text-sm text-charcoal/70">Log in to continue your reflection.</p>
            </div>
            <form onSubmit={submit} className="card-soft p-8 space-y-4">
                {err && <div data-testid="login-error" className="rounded-xl bg-destructive/10 text-destructive text-sm px-4 py-3">{err}</div>}
                <div>
                    <label className="text-sm font-medium">{t("ob.email")}</label>
                    <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                        className="mt-1 w-full rounded-xl border border-charcoal/15 px-4 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-forest/30" />
                </div>
                <div>
                    <label className="text-sm font-medium">{t("ob.password")}</label>
                    <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                        className="mt-1 w-full rounded-xl border border-charcoal/15 px-4 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-forest/30" />
                </div>
                <button data-testid="login-submit" disabled={loading} className="btn-primary w-full py-3 font-medium disabled:opacity-60">
                    {loading ? t("common.loading") : t("nav.login")}
                </button>
            </form>
            <p className="mt-6 text-center text-sm text-charcoal/70">
                New here? <Link to="/onboarding" data-testid="login-to-onboarding" className="text-forest font-semibold underline">{t("nav.start")}</Link>
            </p>
        </div>
    );
}
